import React from 'react';
import {useTable} from 'react-table';
import {FormattedMessage} from 'react-intl';
import {CommonTable} from '../../_common/components/CommonTable/CommonTable';
import {useTransfersByAgentContext} from '../contexts/TransfersByAgentContext';
import styles from './styles.module.scss';

export function TableTransfers() {
  const {columnsTransfers, dataTransfers} = useTransfersByAgentContext();

  return (
    <div className={styles.card}>
      <h3>
        <FormattedMessage
          id="transfersByAgent-transfers-to-agent"
          defaultMessage={`Transfers to agent (${dataTransfers.length})`}
          values={{count: dataTransfers.length}}
        />
      </h3>
      <CommonTable
        tableProps={useTable({columns: columnsTransfers, data: dataTransfers})}
        customContainerStyles={'w-100'}
        customHeaderStyles={styles.tableHeader}
        customContainerID={'transfersTableContainer'}
        customTableStyles={'transfers-main-table'}
        customTableHeadColor={'transfers-tableHead'}
      />
    </div>
  )
}
